export const createDataLayerIfNotExists = () => {
  if (window?.dataLayer) return
  if (window) window.dataLayer = []
}
